export default function ProfilePhoto () {
    return (<div className="logo-container ml-6"><div className="logo" /></div>)
}
